<template>
  <div v-if="isMounted" :key="route">
    <div v-if="currentView =='list' ">
      <page-title :title="settings.pageTitle" />
      <advance-table  v-if="isMounted && settings.tableSettings != null" :key="settings.route" :mainSettings="settings"  @changeView="(data) => currentView=data"></advance-table>
    </div>

    <div v-if="currentView =='edit' ">
      <edit-data  @changeView="(data) => currentView=data" />
    </div>

    <div v-if="currentView =='view' ">
      <view-data  @changeView="(data) => currentView=data" />
    </div>

  </div>
</template>

<script>
import AdvanceTable from "./advance_table.vue";
import PageTitle from "../../components/aron/pageTitle";
import EditData from "./form_edit.vue";
import viewData from "./view_data/form_view.vue";

import { mapGetters } from "vuex";

import { settingsMixin } from "./settingsMixin";

export default {
  components: {
    AdvanceTable,
    PageTitle,
    EditData,
    viewData,
  },
  mixins: [settingsMixin],
  watch: {
    $route(to, from) {
      this.route = this.$route.params.key;
        this.currentView = "list";//reset the view
    }
  },
  methods: {},
  data() {
    return {
      route: "pr",
      isMounted: false,
      currentView: "list"
    };
  },
  computed: {
    ...mapGetters({
      getUserInfo: "auth/getUserInfo"
    }),
    settings() { 
      return this.getSettings(
        this.$route.params.subject,
        this.$route.params.key
      );
    }
  },
  created() {  
  
  },
  mounted() { 
    this.isMounted = true; 
  }
};
</script>